import * as React from 'react';
import {EducationWrapper, Title, ContentWrapper, Wrapper} from './EducationStyles';
import {language} from './EducationLanguage';
import { generateEducationEntries } from './helpers/generateEducationEntries';

export type Props = {
	schema: any
};

export const EducationLayout = (props: Props) =>
{
	const render = () =>
	{
		const internalJSX = generateEducationEntries(props.schema.items)
		const returnValue = (
			<EducationWrapper>
				<Wrapper>
					<Title>
						{props.schema.title}
					</Title>
					<ContentWrapper>
						{internalJSX}
					</ContentWrapper>
				</Wrapper>
			</EducationWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};


